import type { ReactNode } from 'react';

export interface Colonne<T> {
  cle: string;
  /** Presque toujours un libellé ; un nœud pour une case « tout cocher ». */
  entete: ReactNode;
  /** Colonne numérique : alignée à droite, en chasse fixe (charte, § 6.1). */
  num?: boolean;
  rendu: (ligne: T) => ReactNode;
}

/**
 * Tableau dense (charte, doc 06, § 6.1) : filets de 1 px, aucune zébrure,
 * en-tête collant, colonnes numériques à droite.
 */
export function Tableau<T>({
  colonnes,
  lignes,
  cle,
  vide = 'Aucun élément.',
  pied,
}: {
  colonnes: Colonne<T>[];
  lignes: T[];
  cle: (ligne: T, index: number) => string;
  vide?: string;
  pied?: ReactNode;
}) {
  return (
    <table className="tableau">
      <thead>
        <tr>
          {colonnes.map((c) => (
            <th key={c.cle} scope="col" className={c.num ? 'num' : undefined}>
              {c.entete}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {lignes.length === 0 ? (
          <tr>
            <td colSpan={colonnes.length} className="tableau__vide">
              {vide}
            </td>
          </tr>
        ) : (
          lignes.map((ligne, index) => (
            <tr key={cle(ligne, index)}>
              {colonnes.map((c) => (
                <td key={c.cle} className={c.num ? 'num' : undefined}>
                  {c.rendu(ligne)}
                </td>
              ))}
            </tr>
          ))
        )}
      </tbody>
      {pied}
    </table>
  );
}

export function Bloc({
  titre,
  meta,
  actions,
  children,
}: {
  titre: string;
  meta?: string;
  actions?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="bloc">
      <div className="bloc__titre">
        <h2>{titre}</h2>
        <span className="meta">
          {meta}
          {actions}
        </span>
      </div>
      {children}
    </section>
  );
}
